var BaseViews = require('../base');

require('./slider/slider.scss');
var Slider = BaseViews.LayoutView.extend({
    _preloadQueue: null,
    _playingTimeoutID: null,
    _currentSlideModel: null,
    _stopped: null,
    template: require('./slider/slider.html'),
    className: 'fmcy-slider full',
    ui: {
        previousBtn: '.fmcy-slider-control-prev',
        nextBtn: '.fmcy-slider-control-next'
    },
    events: {
        'click @ui.previousBtn': 'previousClicked',
        'click @ui.nextBtn': 'nextClicked'
    },
    regions: {
        loaderRegion: '.fmcy-loader-region',
        slideLayerARegion: '.fmcy-slide-layer-a-region',
        slideLayerBRegion: '.fmcy-slide-layer-b-region'
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(options || {}, {
            animationStyleShow: 'long',
            pauseOnHover: true,
            showSlideDuration: 8000,
            imagePreloadTimeout: 60000,
            fullScreen: true,
            showNavigationButtons: false,
            menuItemThumbOptions: {}
        });

        _.bindAll(this, '_displaySlide');

        var createjs = require('preload-js');
        createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
        self._preloadQueue = new createjs.LoadQueue(false);
        self._stopped = true;

        self._state = new Backbone.Model({
            paused: false
        });

    },
    serializeData: function () {
        return {
            options: this.options
        };
    },
    nextClicked: function (e) {
        e.preventDefault();
        var nextSlide = this.collection.next(this._currentSlideModel);
        if (nextSlide) {
            this._currentSlideModel = nextSlide;
        } else {
            this._currentSlideModel = this.collection.at(0);
        }
        this._displaySlide(this._currentSlideModel);
    },
    previousClicked: function (e) {
        e.preventDefault();
        var prevSlide = this.collection.prev(this._currentSlideModel);
        if (prevSlide) {
            this._currentSlideModel = prevSlide;
        } else {
            this._currentSlideModel = this.collection.at(0);
        }
        this._displaySlide(this._currentSlideModel);
    },
    onBeforeShow: function () {
        var self = this;

        self._toggleLoader(true);
        var maybeStartSliding = function () {
            if (!self.options.showNavigationButtons) {
                if (self._stopped) {
                    self._stopped = false;
                    self._cycle(true);
                }
            } else if (!self._currentSlideModel) {
                self._currentSlideModel = self.collection.at(0);
                self._displaySlide(self._currentSlideModel);
            }
        };
        self.collection.on('add reset', maybeStartSliding);

        if (self.options.pauseOnHover) {
            self.$el.hover(
                self.pause.bind(self),
                self.play.bind(self)
            );
        }

        if (self.collection.size()) {
            maybeStartSliding();
        }
        if (self.options.fullScreen) {
            self.$el.addClass('fmcy-full-screen');
        }
    },
    _toggleLoader: function (on) {
        if (on) {
            this.loaderRegion.show(
                new(require('treeline-shared-components/spinner'))({
                    message: ''
                })
            );
        } else {
            this.loaderRegion.empty();
        }
    },
    _cycle: function (firstSlide) {
        var self = this;

        if (self._playingTimeoutID) {
            clearTimeout(self._playingTimeoutID);
            self._playingTimeoutID = null;
        }

        if (self._state.get('paused')) {
            return;
        }

        function nextSlide() {
          if (!self.isRendered) {
              return;
          }


          if (!self.collection.size()) {
              self._stopped = true;
              return;
          }

          var nextSlideModel;
          if (!self._currentSlideModel) {
              nextSlideModel = self.collection.at(0);
          } else {
              nextSlideModel = self.collection.next(self._currentSlideModel);
              if (!nextSlideModel) {
                  nextSlideModel = self.collection.at(0);
              }
          }

          if (!nextSlideModel || nextSlideModel === self._currentSlideModel) {
              self._stopped = true;
              return;
          }

          self._currentSlideModel = nextSlideModel;

          self._displaySlide(
              nextSlideModel,
              function () {
                  self._cycle();
              }
          );
          var nextItem = self.collection.next(nextSlideModel);
          if (nextItem) {
              self._preloadQueue.loadFile({
                  id: nextItem.id,
                  src: self.options.getItemDisplayImageURL(nextItem, 'large')
              });
          }
        }

        if (firstSlide) {
          nextSlide();
          return;
        }

        if (self._currentSlideModel.get('type') == 'video') {
          var slide;
          if (self.slideViewA == null) {
            slide = self.slideViewB;
          } else {
            slide = self.slideViewA;
          }
          slide.on('videoplayer:ended', function () {
            nextSlide();
          });
        } else {
          self._playingTimeoutID = setTimeout(function () {
            nextSlide();
          }, self.options.showSlideDuration);
        }
    },
    pause: function () {
        this._state.set('paused', true);
        if (this._playingTimeoutID) {
            clearTimeout(this._playingTimeoutID);
            this._playingTimeoutID = null;
        }
    },
    play: function () {
        this._state.set('paused', false);
        if (!this._stopped) {
            this._cycle();
        }
    },
    _displaySlide: function (slideModel, displayedCallback) {
        var self = this;

        function createSlide(item, callback) {
            var handleFileLoaded;
            var handleFileLoadError;

            function callbackWithView(displayImageURL) {
                self.createSlide(item, displayImageURL).then(function (slide) {
                    slide.$el.addClass('fmcy-slider-slide');
                    callback(slide);
                });
            }
            handleFileLoadError = function (event) {
                if (!self.isRendered) {
                    return;
                }
                if (event.item.id === item.id) {
                    console.log('File load error occurred: ', event);
                    self._preloadQueue.removeAllEventListeners('fileload');
                    self._preloadQueue.removeAllEventListeners('error');
                    callbackWithView(null);
                }
            };

            handleFileLoaded = function (event) {
                if (!self.isRendered) {
                    return;
                }
                if (event.item.id === item.id) {
                    self._preloadQueue.removeAllEventListeners('fileload');
                    self._preloadQueue.removeAllEventListeners('error');
                    callbackWithView(event.item.src);
                }
            };

            self._preloadQueue.on('error', handleFileLoadError);
            self._preloadQueue.on('fileload', handleFileLoaded);
            self._preloadQueue.loadFile({
                id: item.id,
                src: self.options.getItemDisplayImageURL(item, 'large')
            });
        }

        if (self.slideViewA) {
            createSlide(slideModel, function (slideView) {
                self._toggleLoader(false);
                self.slideViewB = slideView;
                if (self.slideViewA) {
                    self.hideSlide(self.slideViewA, function () {
                        if (!self.isRendered) {
                            return false;
                        }
                        self.slideLayerARegion.empty();
                    });
                }
                self.slideViewA = null;
                self.slideViewB.on('show', function () {
                    self.showSlide(self.slideViewB);
                });
                self.slideLayerBRegion.show(self.slideViewB);
                if (displayedCallback) {
                    displayedCallback();
                }
            });
        } else {
            createSlide(slideModel, function (slideView) {
                self._toggleLoader(false);
                self.slideViewA = slideView;
                if (self.slideViewB) {
                    self.hideSlide(self.slideViewB, function () {
                        if (!self.isRendered) {
                            return false;
                        }
                        self.slideLayerBRegion.empty();
                    });
                }
                self.slideViewB = null;
                self.slideViewA.on('show', function () {
                    self.showSlide(self.slideViewA);
                });
                self.slideLayerARegion.show(self.slideViewA);
                if (displayedCallback) {
                    displayedCallback();
                }
            });
        }
    },
    hideSlide: function (slideView, completedCallback) {
      window.gsap.fromTo(slideView.$el,
      {
        opacity: 1
      },
      {
        opacity: 0,
        duration: 2,
        onComplete: function () {
          if (completedCallback) {
              completedCallback();
          }
        }
      });
    },
    showSlide: function (slideView, completedCallback) {
      window.gsap.fromTo(slideView.$el,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 2,
        onComplete: function () {
          if (completedCallback) {
              completedCallback();
          }
        }
      });
    }
});
module.exports = Slider;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/slider.js
 **/